/*
From WHATWG we have (see  https://html.spec.whatwg.org/#valid-e-mail-address).

    ^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$

It is used in <input type="email">. And "1@1" is valid email address by it.

Throwing away non-common cases:

    ^
        [a-zA-Z0-9][a-zA-Z0-9.+=?^_~-]*     -- login starting with an alpha character or a digit
        @
        (
            [a-zA-Z0-9]                         -- subdomains can have a single alpha or digit
            (?:
                [a-zA-Z0-9-]{0,61}                  -- optional hyphens inside
                [a-zA-Z0-9]                         -- ending with alpha or digit
            )?
            \.                                  -- dot is a must
        )+                                  -- optional subdomain parts ending with dots
        [a-zA-Z]{2,63}                      -- at least 2-character top-level domain (TLD)
    $
 */

export const validationPattern =
    "^[a-zA-Z0-9][a-zA-Z0-9.+=?^_~-]*@([a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\\.)+[a-zA-Z]{2,63}$"

export const validationErrText = "Пожалуйста, введите корректный адрес почты"
